/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Button, Dialog, Typography2 } from '@coursera/cds-core';
import { ReviewIcon } from '@coursera/cds-icons';

import _t from 'i18n!nls/peer';

const styles = {
  iconContainer: () => css`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 6rem;
  `,
  subtext: () => css`
    margin-bottom: var(--cds-spacing-400);
  `,
  reviewIcon: () => css`
    transform: scale(2.5);
  `,
};

const { HeadingGroup, Content, Actions } = Dialog;

type Props = {
  onClose(): void;
};

const FeedbackTipsModal: React.FC<Props> = ({ onClose }) => {
  return (
    <Dialog open={true} onClose={onClose}>
      <div css={styles.iconContainer}>
        <ReviewIcon css={styles.reviewIcon} size="large" color="interactive" />
      </div>
      <HeadingGroup>{_t('Tips for providing great feedback')}</HeadingGroup>
      <Content>
        <Typography2 css={styles.subtext} component="p" variant="subtitleMedium">
          {_t("Your peers will benefit from feedback that's specific, easy to understand, and helpful.")}
        </Typography2>
        <ul>
          <li>
            <Typography2 component="p" variant="bodyPrimary">
              {_t('What did your peer do well?')}
            </Typography2>
          </li>
          <li>
            <Typography2 component="p" variant="bodyPrimary">
              {_t('Where can they improve?')}
            </Typography2>
          </li>
          <li>
            <Typography2 component="p" variant="bodyPrimary">
              {_t('Does their work meet the grading criteria for this assignment?')}
            </Typography2>
          </li>
        </ul>
      </Content>
      <Actions>
        <Button size="medium" variant="primary" onClick={onClose}>
          {_t('Continue')}
        </Button>
      </Actions>
    </Dialog>
  );
};

export default FeedbackTipsModal;
